import {
  AdvanceInvestmentFilter,
  MaxProjectionYear,
} from "../helpers/constant";
import { SET_NOTIFICATION_SUMMARY } from "../helpers/vuex-constants";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { GET_AUTH_INFORMATION } from "../helpers/vuex-constants";
import { CommonHelper } from "../helpers";
export default {
  data() {
    return {
      selectedComponent: "chart-area",
      chartProperties: {},
      selectedTabComponent: "balanceGraph",
      chartGraphData: [],
      chartData: {
        areaChart0: [],
        barChart1: [],
        barChart2: [],
      },
      rightToolSummary: [
        { key: "Projected Balance", value: "$0" },
        { key: "Cumulative Return", value: "$0" },
        { key: "Net Contribution", value: "0 years" },
      ],
      chartTabContent: [
        {
          text: "Balance",
          id: "balanceGraph",
          active: true,
        },
        {
          text: "Contribution & Withdrawals",
          id: "contributionWithdrawalGraph",
          active: false,
        },
        {
          text: "Return & Fees",
          id: "ReturnFeesGraph",
          active: false,
        },
      ],
      chartTabContentTableView: [
        {
          text: "Details",
          id: "chart-area",
          active: true,
          visible: true,
        },
      ],
      projectionYear: {
        Value: 0,
        Maxvalue: MaxProjectionYear,
        IsError: false,
        ErrorText: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      loginUserInfo: GET_AUTH_INFORMATION,
    }),
    barChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 20],
        domainY: [0, 600000],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],
        yAxisLabel: "Repayment Amount",
        legendKeyType: "bar",
        areaLegendKey: "bar",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },

    areaChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 2, 4, 6, 8, 10],
        domainY: [0, 600000],
        tickQuantityY: 5,
        areaLegendItems: "Loan",
        yAxisLabel: "Loan Balance",
        areaLegendKey: "bar",
        lineChartColor: "#2056af",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },
  },
  methods: {
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
    }),

    createrowModel(data) {
      let NewData = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let currentRow = data[i];
          NewData[i] = {};
          for (var key of Object.keys(currentRow)) {
            NewData[i][key] = {
              value: currentRow[key],
              IsError: false,
              ErrorText: [],
            };
          }
        }
      }
      return NewData;
    },

    fillInvestmentModel(typeId) {
      if (this.baselineFilterObject.advancedetails == null) {
        this.baselineFilterObject.advancedetails = this.getUserInputData(
          this.rows
        );
      } else {
        let data = this.baselineFilterObject.advancedetails.filter(
          (sr) => sr.typeId.value != typeId
        );
        let advancedetails = data.concat(this.getUserInputData(this.rows));
        this.baselineFilterObject.advancedetails = advancedetails;
      }

      this.$emit("resetBaselineData", this.baselineFilterObject);
    },

    DescriptionAdditionalForm(data, typeId) {
      if (data == undefined || data == "") {
        if (typeId == AdvanceInvestmentFilter.Return) {
          return "Return";
        } else if (typeId == AdvanceInvestmentFilter.Contribution) {
          return "Contribution";
        } else if (typeId == AdvanceInvestmentFilter.Maturity) {
          return "Maturity";
        } else if (typeId == AdvanceInvestmentFilter.Withdrawal) {
          return "Withdrawal";
        } else if (typeId == AdvanceInvestmentFilter.MarketCrash) {
          return "Market Crash";
        } 
      } else {
        return data;
      }
    },
    createSaveInvestmentModel(investemntUiModel, selectedInvestment) {
      let investmentModel = {};
      investmentModel.clientId = selectedInvestment.clientId;
      investmentModel.ownerId = selectedInvestment.ownerId;
      investmentModel.investmentID = 0;
      investmentModel.description = selectedInvestment.description;
      investmentModel.contributionAmount = investemntUiModel.contributionAmount;
      investmentModel.frequencyId = investemntUiModel.durationTypeId;
      investmentModel.ownerEntityTypeId = selectedInvestment.ownerEntityType;
      investmentModel.frankedRate = investemntUiModel.frankingRate;
      investmentModel.growthRate = investemntUiModel.growthRate;
      investmentModel.incomeRate = investemntUiModel.incomeRate;
      investmentModel.platformid = investemntUiModel.platformId;

      investmentModel.investmentGuid = selectedInvestment.investmentGuid;
      investmentModel.parentInvestmentGuid =
        selectedInvestment.parentInvestmentGuid;
      investmentModel.projectionYear = selectedInvestment.projectionYear;
      investmentModel.investmentAmount = investemntUiModel.amount;
      investmentModel.investmentID = 0;
      investmentModel.isDRP = investemntUiModel.isDRP;
      investmentModel.riskProfileId = investemntUiModel.riskProfileId;
      investmentModel.investmentClassID = selectedInvestment.investmentClassID;
      investmentModel.isRenewAuto = selectedInvestment.isRenewAuto;
      investmentModel.maturityDate = selectedInvestment.maturityDate;
      investmentModel.advancedetails = selectedInvestment.advancedetails;
      investmentModel.isExisting = selectedInvestment.isExisting;

      investmentModel.userId = this.loginUserInfo.adviserId;
      return investmentModel;
    },
    async saveInvestmentData(apiResponse, data, isUpdate) {
      if (apiResponse && apiResponse.status == 200) {
        this.setNotificationSummary({
          isShow: true,
          variation: "success",
          text:
            isUpdate == 0
              ? `Investment instance ${data.description} has been added.`
              : `Investment instance ${data.description} has been updated.`,
        });
      } else {
        this.setNotificationSummary({
          isShow: true,
          variation: "error",
          text: `Failed to add Investment instance ${data.description}.`,
        });
      }
      this.$router.push({ name: "investment-instance-selection" });
    },
    RemapGraphsModel() {
      this.rightToolSummary = [
        {
          key: "Projected Balance",
          value: this.projectionModel.projectedBalance,
        },
        {
          key: "Cumulative Return",
          value: this.projectionModel.cumulativeReturn,
        },
        {
          key: "Net Contribution",
          value: this.projectionModel.netContribution,
        },
      ];
      this.chartData = {
        contributionWithdrawalGraph:
          this.projectionModel.contributionWithdrawalGraphData,
        balanceGraph: this.projectionModel.balanceGraphData,
        ReturnFeesGraph: this.projectionModel.ReturnFeesGraphData,
      };
      this.onChangeChartTab(this.selectedTabComponent);
    },
    onChangeChartTab(tabId) {
      if (this.chartData[tabId]) {
        this.selectedTabComponent = tabId;
        let legendItems = [];
        let legendColors = [];
        let yAxisLabel = "Asset Balance";
        if (this.selectedTabComponent == "balanceGraph") {
          this.selectedComponent = "chart-area";
          legendItems = "Balance";
          this.chartProperties = this.GetAreaChartProperties(
            this.chartData[tabId],
            legendItems,
            yAxisLabel
          );
          this.chartGraphData = this.chartData[tabId].data;
        } else {
          this.selectedComponent = "chart-bar";

          if (tabId == "contributionWithdrawalGraph") {
            legendItems = ["Contribution", "Withdrawal"];
            legendColors = ["#7999cf", "#ff6666"];
            yAxisLabel = "Contribution & Withdrawals";
          } else {
            legendItems = ["Income", "Growth", "Fees"];
            legendColors = ["#7999cf", "#f9dc66", "#ff6666"];
            yAxisLabel = "Return & Fees";
          }
          this.chartProperties = this.GetBarChartProperties(
            this.chartData[tabId],
            legendItems,
            legendColors,
            yAxisLabel
          );
          this.chartGraphData = this.chartData[tabId].data;
        }
      }
    },

    GetBarChartProperties(chartData, legendItems, legendColors, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );
      let roundOffYMinaxis =
        chartData.minYAxis > 0
          ? -CommonHelper.getRoundOffValueForAxis(
              0,
              Math.ceil(chartData.minYAxis),
              5
            )
          : 0;
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.barChartProperties.legendItems = legendItems;
      this.barChartProperties.color = legendColors;
      this.barChartProperties.yAxisLabel = yAxisLabel;
      this.barChartProperties.domainX = [0, chartData.maxXAxis];
      this.barChartProperties.domainY = [roundOffYMinaxis, roundOffYaxis];
      return this.barChartProperties;
    },
    GetAreaChartProperties(chartData, legendItems, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );

      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.areaChartProperties.areaLegendItems = legendItems;
      this.areaChartProperties.domainX = [0, this.projectionYear.Value];
      this.areaChartProperties.yAxisLabel = yAxisLabel;
      this.areaChartProperties.tickX = 0;
      this.areaChartProperties.domainY = [0, roundOffYaxis];
      return this.areaChartProperties;
    },
  },
};
